import axios from 'axios'
import store from '@/services/store'
import router from '@/services/routes'

// public
export const publicAxios = axios.create({
    baseURL: process.env.VUE_APP_API,
	headers: {
		'Content-Type': 'application/json'
	}
})

publicAxios.interceptors.request.use(async(config) => {
	config.headers.Application = `${store.state.axiosToken}`
	return config
})

// private
export const privateAxios = axios.create({
    baseURL: process.env.VUE_APP_API,
	headers: {
		'Content-Type': 'application/json'
	}
})

privateAxios.interceptors.response.use(async(response) => {
    return response
}, (error) => {
	if (error.response.status === 401) {
		store.dispatch('logout', true)
	}
	if (error.response.status === 404) {
		if (error.response.data.status === 1018
			&& router.history.current.fullPath !== '/team/fallback'
		) {
			router.push('/team/fallback')
		}
	}
	if (error.response.data.status === 1022) {
		store.dispatch('setShowExpirationDialog', true)
	}
	return Promise.reject(error)
})

privateAxios.interceptors.request.use(async(config) => {
	if (isAccessTokenExpired() && getRefreshToken()) {
		await loadRefreshToken()
		.then(response => {
			store.dispatch('setAuth', response.data)
		})
		.catch(() => {
			store.dispatch('logout')
		})
	}
	if (getAccessToken()) {
		config.headers.Authorization = `Bearer ${getAccessToken()}`
	}
	if (getTeamId()) {
		config.headers.TeamId = getTeamId()
	}
	if (getGuestId()) {
		config.headers.GuestId = `${store.state.guestId}`
	}
	config.headers.Application = `${store.state.axiosToken}`
	return config
})

const isAccessTokenExpired = () => {
	return Math.round(Date.now() / 1000) > store.state.auth.expires_at
}

const getRefreshToken = () => {
	return store.state.auth.refresh_token
}

const getAccessToken = () => {
	return store.state.auth.access_token
}

const loadRefreshToken = () => {
	return axios.post(`${process.env.VUE_APP_API}/auth/login?grant_type=refresh_token&refresh_token=${getRefreshToken()}&client_id=browser`)
}

const getTeamId = () => {
	return store.state.userTeam !== {} ? store.state.userTeam.id : ''
}

const getGuestId = () => {
	return store.state.guestId ? store.state.guestId : ''
}
